import { render, staticRenderFns } from "./Appel.vue?vue&type=template&id=16c7b588"
import script from "./Appel.vue?vue&type=script&lang=js"
export * from "./Appel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports